import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PricingCompareTable } from "./PricingCompareTable";

export const Pricing = () => {
    return (
        <section
            id="pricing"
            className="relative py-24 sm:py-32 overflow-hidden"
            data-testid="pricing-section"
        >
            <div className="absolute inset-0 radial-glow-amber pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 sm:px-8 relative">
                <div className="max-w-3xl mb-12">
                    <p className="text-xs uppercase tracking-[0.25em] text-electric font-semibold mb-4">
                        PRICING
                    </p>
                    <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.06]">
                        One platform.{" "}
                        <span className="text-zinc-500">
                            Every feature on every plan.
                        </span>
                    </h2>
                    <p className="mt-5 text-zinc-400 font-light">
                        Dashboard, Sales, HR, Projects, Finance, Documents &
                        Communications - full access on every plan. Compare
                        license bands and pick what fits your team.
                    </p>
                </div>

                <PricingCompareTable testId="pricing-section-table" yearly />

                <div className="mt-8 text-center">
                    <Link
                        to="/pricing"
                        className="inline-flex items-center gap-2 text-sm font-semibold text-electric hover:text-white transition"
                    >
                        View full module breakdown
                        <ArrowUpRight className="w-4 h-4" />
                    </Link>
                </div>
            </div>
        </section>
    );
};
